import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';

import PaymentsForm from './PaymentsForm';


interface IMonitorModalProps {
    open: boolean,
    handleClose: () => void;
}

const PaymentsModal: React.FC<IMonitorModalProps> = ({open, handleClose}) => {

    return <MainModal
        header={t`Внесение оплаты`}
        open={open}
        handleClose={handleClose}
        size="md"
    >
        <PaymentsForm onClose={handleClose}/>
    </MainModal>;
};

export default PaymentsModal;